import home from '@/views/mamixiaowu/home.vue'
import workspace from '@/views/mamixiaowu/workspace.vue'
import declare from '@/views/mamixiaowu/declare.vue'
import dealList from '@/views/mamixiaowu/dealList.vue'
export default [{
  path: '/mamixiaowu',
  name: 'mamixiaowu',
  meta: {
    title: '首页',
    NeedLogin: false,
    keepAlive: true
  },
  component: home
},
{
  path: '/mamixiaowu/workspace',
  name: 'mamixiaowuWorkspace',
  meta: {
    title: '工作台',
    NeedLogin: false,
    keepAlive: false
  },
  component: workspace,
  children: [{
    path: 'declare',
    name: 'mamixiaowuWorkspaceDeclare',
    meta: {
      title: '小屋申报',
      NeedLogin: false,
      keepAlive: false
    },
    component: declare
  }, {
    path: 'dealList',
    name: 'mamixiaowuWorkspaceDealList',
    meta: {
      title: '信息处理',
      NeedLogin: false,
      keepAlive: false
    },
    component: dealList
  },
  {
    path: 'userList',
    name: 'mamixiaowuWorkspaceUserList',
    meta: {
      title: '账号管理',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/mamixiaowu/workspace_zhgl.vue'], resolve)
    }
  }
  ]
}, {
  path: '/mamixiaowu/declareDetail/:id',
  name: 'shenbaojieguoDeclareDetail2',
  meta: {
    title: '申报详情',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/mamixiaowu/declareDetail.vue'], resolve)
  }
},
{
  path: '/mamixiaowu/declareEdit/:id',
  name: 'mamixiaowuDeclareEdit',
  meta: {
    title: '小屋申报',
    NeedLogin: false,
    keepAlive: false
  },
  component: declare
},
{
  path: '/mamixiaowu/create',
  name: 'create',
  meta: {
    title: '新增人员',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/mamixiaowu/xinzengrenyuan.vue'], resolve)
  }
},
{
  path: '/mamixiaowu/detail',
  name: 'detail',
  meta: {
    title: '小屋详情',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/mamixiaowu/xiaojiaxiangqing.vue'], resolve)
  }
},
{
  path: '/mamixiaowu/modify',
  name: 'modify',
  meta: {
    title: '修改人员',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/mamixiaowu/modify.vue'], resolve)
  }
}
]
